export default class PaginationParams {
  limit: number = 10;

  offset: number = 0;

  sortBy?: string;

  order: 'asc' | 'desc' = 'asc';
}
